import React, { SVGProps } from 'react';

interface FileUploadOutlineIconProps extends SVGProps<SVGSVGElement> {
	color?: string;
}

function AccountGroupIcon({ color, ...props }: FileUploadOutlineIconProps) {
	return (
		<svg
			width={25}
			height={15}
			viewBox="0 0 25 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				d="M12.5.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7zM5.5 3c.56 0 1.08.15 1.53.42-.15 1.43.27 2.85 1.13 3.96A2.997 2.997 0 012.5 6a3 3 0 013-3zm14 0a3 3 0 010 6c-1.16 0-2.16-.66-2.66-1.62a5.536 5.536 0 001.13-3.96c.45-.27.97-.42 1.53-.42zM6 13.25c0-2.07 2.91-3.75 6.5-3.75s6.5 1.68 6.5 3.75V15H6v-1.75zM.5 15v-1.5c0-1.39 1.89-2.56 4.45-2.9-.59.68-.95 1.62-.95 2.65V15H.5zm24 0H21v-1.75c0-1.03-.36-1.97-.95-2.65 2.56.34 4.45 1.51 4.45 2.9V15z"
				fill={color || '#768D95'}
			/>
		</svg>
	);
}

export default AccountGroupIcon;
